import { type PreferredProductData } from "~/features/productDetails/models/PdpPageProductData";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { SearchProductDataDTO } from "~/features/search/models/SearchResultsDTO";
import { transformSrpProduct } from "~/features/search/transformers/transformSrpProduct";
import type { SrpProductData } from "~/utils/models";
import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";

type NewResultType = {
  preferred: PreferredProductData[];
  sales: SrpProductData[];
  showSimilarSalesBlock: boolean;
};

export type PreferredProductCardDTO = Pick<
  ProductDataDTO,
  "code" | "designation" | "sapMaterialNumber" | "url" | "images" | "preferred" | "stockAmount" | "salesCampaigns"
>;

export interface PreferredProductsResponseDTO {
  preferredProducts?: PreferredProductCardDTO[];
  productsOnSale?: PreferredProductCardDTO[];
  showSimilarSalesBlock?: boolean;
}

export async function fetchPreferredProducts(productCode: string): Promise<NewResultType> {
  const apiUrl = occUrl(`/p/${productCode}/preferred`);

  const response = await occFetch(apiUrl);
  if (response.ok) {
    const data = (await response.json()) as PreferredProductsResponseDTO;
    return {
      preferred: (data.preferredProducts ?? []).map((product) => ({
        ...product,
        images: product.images ?? [],
        preferred: product.preferred ?? false,
      })),
      // The endpoint intentionally returns the same compact card DTO in both arrays.
      sales: (data.productsOnSale ?? []).map((product) => transformSrpProduct(product as SearchProductDataDTO)),
      showSimilarSalesBlock: data.showSimilarSalesBlock ?? false,
    };
  }
  throw new Error("Error fetching data");
}
